/**
 * @generated SignedSource<<ffdd6724a5248c6d3107fc9dc229bfd0>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CallDealerModal_item$data = {
  readonly serviceId: string | null;
  readonly title: string | null;
  readonly " $fragmentType": "CallDealerModal_item";
};
export type CallDealerModal_item$key = {
  readonly " $data"?: CallDealerModal_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"CallDealerModal_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CallDealerModal_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "8a0622c8f30902723b719505e0e1dab5";

export default node;
